import './index.less'
import { useEffect, useState } from 'react'
import { SearchBox, tag2criteria } from '../SearchBox'
import { OverViewType } from './OverViewType'
import { TableViewType } from './TableViewType'
import { useAppDispatch, useAppSelector } from '@/hooks'
import { downloadPageInfo, getWorkListByTags, httpRequest_download } from '@/server'
import { DOWNLOAD_PAGE_URL } from '@/server/apiConfig'
import {
  setNowPage,
  setOverviewList,
  setSelectedType,
  setTotal
} from '@/features/SetOverviewTypeList/setOverviewTypeList'
import { setToken } from '@/features/Login/login'
import { useNavigate } from 'react-router-dom'
import { Button, message } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import { setIsLoading } from '@/features/SetSearchKey'

interface OverviewProps {
  setComponent: Function
}
export interface showPaintingI {
  workId: string
  workName: string
  museum: string //博物馆
  mediaType: string //材质
  materialType: string //设色
  styleType: string //形制
  size: number[] //[horizontal,vertical]
  authorName: string
  dynasty: string
  src: string //tilesPath
}
export interface searchResultI {
  workId: string
  workName: string
  museum: string //博物馆
  mediaType: string //材质
  materialType: string //设色
  styleType: string //形制
  horizontal?: number //高
  vertical?: number //宽
  authorName: string
  dynasty: string
  class1: string //主题
  class2: string //类型
  tilesPath: string //tilesPath
  src: string //缩略图
}
// 浏览页面
export function OverViewPage(props: OverviewProps) {
  const navigate = useNavigate()
  const token = useAppSelector((state) => state.login.token)
  const searchData = useAppSelector((state) => state.searchKey.searchData)
  // 缓存的tagsList和keyword
  const tagsList = useAppSelector((state) => state.overviewTagsList.tagsList)
  const keyword = useAppSelector((state) => state.overviewTagsList.keyword)
  // 导出文件时，后端是否准备好数据
  const isLoading = useAppSelector((state) => state.searchKey.isLoading)
  const dispatch = useAppDispatch()
  // 浏览(0)/表单(1)模式
  const selectedType = useAppSelector((state) => state.overviewTypeList.selectedType)
  // 画作当前展示的页数
  const nowPage = useAppSelector((state) => state.overviewTypeList.nowPage)
  // 分页器状态
  const [pageState, setPageState] = useState<any>([])
  // 总页数
  const [pageTotal, setPageTotal] = useState<number>(1)
  // 一页的容量
  const size = selectedType === 0 ? 8 : 14
  // 画作数量
  const paintingNum = useAppSelector((state) => state.overviewTypeList.total)
  useEffect(() => {
    setPageTotal(Math.ceil(paintingNum / size))
  }, [paintingNum, selectedType])
  // 切换页面
  const handleChangePage = function (index: number) {
    if (index < 1 || index > pageTotal) return
    dispatch(setNowPage(index))
    // 重新请求数据
    // 整理数据
    const dataObj: {
      keyword: string
      criteria: { key: string; value: string[] }[]
      pages: { page: number; size: number }
    } = {
      keyword: keyword,
      criteria: [],
      pages: {
        page: index,
        size: size
      }
    }
    for (const key in tagsList) {
      if (tagsList[key].length > 0) {
        dataObj.criteria.push({ key: tag2criteria[key], value: tagsList[key] })
      }
    }
    //重新发起不同size的请求
    getWorkListByTags(token, dataObj).then((res) => {
      if (res.data.code === '10056') {
        //token失效
        window.confirm('登录已过期，请重新登录！')
        dispatch(setToken(''))
        navigate('/')
      } else {
        const list = res.data.content.list.map((item) => {
          // downloadImage(item.encoding)
          return {
            workId: item.workid,
            workName: item.workname,
            museum: item.instname,
            mediaType: item.mediatype,
            materialType: item.materialtype,
            styleType: item.styletype,
            horizontal: item.horizontal,
            vertical: item.vertical,
            authorName: item.authorname,
            dynasty: item.dynasty,
            class1: item.class1,
            class2: item.class2,
            src: item.encoding,
            tilesPath: item.tilesPath
          }
        })
        dispatch(setTotal(res.data.content.total))
        dispatch(setOverviewList(list))
      }
    })
  }
  // 切换展现模式
  const handleChangeType = function (type: number) {
    // 选择页数置位1
    dispatch(setNowPage(1))
    const size = type === 0 ? 8 : 14
    //整理数据
    const dataObj: {
      keyword: string
      criteria: { key: string; value: string[] }[]
      pages: { page: number; size: number }
    } = {
      keyword: keyword,
      criteria: [],
      pages: {
        page: 1,
        size: size
      }
    }
    for (const key in tagsList) {
      if (tagsList[key].length > 0) {
        dataObj.criteria.push({ key: tag2criteria[key], value: tagsList[key] })
      }
    }
    //重新发起不同size的请求
    getWorkListByTags(token, dataObj).then((res) => {
      if (res.data.code === '10056') {
        //token失效
        window.confirm('登录已过期，请重新登录！')
        dispatch(setToken(''))
        navigate('/')
      } else {
        const list = res.data.content.list.map((item) => {
          return {
            workId: item.workid,
            workName: item.workname,
            museum: item.instname,
            mediaType: item.mediatype,
            materialType: item.materialtype,
            styleType: item.styletype,
            horizontal: item.horizontal,
            vertical: item.vertical,
            authorName: item.authorname,
            dynasty: item.dynasty,
            class1: item.class1,
            class2: item.class2,
            src: item.encoding,
            tilesPath: item.tilesPath
          }
        })
        dispatch(setTotal(res.data.content.total))
        dispatch(setOverviewList(list))
      }
    })
    dispatch(setSelectedType(type))
  }
  // 更新分页器状态
  useEffect(() => {
    // 阈值
    if (pageTotal < 22) {
      setPageState(
        Array(pageTotal)
          .fill(0)
          .map((_item, i) => i + 1)
      )
    } else {
      if (nowPage <= 3) {
        setPageState([1, 2, 3, 4, 'R', pageTotal])
      } else if (nowPage >= pageTotal - 2) {
        setPageState([1, 'L', pageTotal - 3, pageTotal - 2, pageTotal - 1, pageTotal])
      } else {
        setPageState([1, 'L', nowPage - 1, nowPage, nowPage + 1, 'R', pageTotal])
      }
    }
  }, [pageTotal, nowPage])
  return (
    <div className='overview-details-body'>
      <div className='overview-details-painting-list'>
        <div className='list-head'>
          <div className='type-btn-area'>
            <div
              className={'type-btn ' + (selectedType === 0 ? 'type-btn-selected' : '')}
              onClick={(_e) => handleChangeType(0)}
            >
              浏览页面
            </div>
            <div
              className={'type-btn ' + (selectedType === 1 ? 'type-btn-selected' : '')}
              onClick={(_e) => handleChangeType(1)}
            >
              表单页面
            </div>
          </div>
          <div className='painting-num'>
            <Button
              type='primary'
              size='large'
              style={{
                backgroundColor: '#E7E1DC',
                width: '150px',
                marginRight: '20px',
                color: '#9A806E'
              }}
              loading={isLoading}
              onClick={async (_e) => {
                if (searchData) {
                  dispatch(setIsLoading(true))
                  try {
                    await httpRequest_download.post('', searchData, {
                      headers: {
                        Authorization: token
                      }
                    })
                    dispatch(setIsLoading(false))
                    downloadPageInfo(DOWNLOAD_PAGE_URL)
                  } catch (_) {
                    message.error('导出失败')
                    dispatch(setIsLoading(false))
                  }
                }
              }}
            >
              <DownloadOutlined />
              导出页面
            </Button>
            画作共{paintingNum}幅
          </div>
        </div>
        {selectedType === 0 ? (
          <OverViewType setComponent={props.setComponent} />
        ) : (
          <TableViewType setComponent={props.setComponent} />
        )}
        <div className='overview-type-list-foot'>
          <div
            className='pre-btn'
            onClick={() => handleChangePage(nowPage - 1)}
            style={{
              cursor: nowPage === 1 ? 'auto' : 'pointer',
              color: nowPage === 1 ? 'gray' : '#9b7a65',
              borderColor: nowPage === 1 ? 'gray' : '#9b7a65'
            }}
          >
            {'< 上一页'}
          </div>
          <div className='page-box'>
            {pageState.map((item, _index) => {
              if (item === 'L') {
                return (
                  <div className='ellipsis-btn' onClick={() => handleChangePage(nowPage - 3)}>
                    ···
                  </div>
                )
              } else if (item === 'R') {
                return (
                  <div className='ellipsis-btn' onClick={() => handleChangePage(nowPage + 3)}>
                    ···
                  </div>
                )
              } else {
                return (
                  <div
                    className='page-btn'
                    onClick={() => handleChangePage(item)}
                    style={{
                      cursor: nowPage === item ? 'auto' : 'pointer',
                      color: nowPage === item ? 'white' : '#9b7a65',
                      backgroundColor: nowPage === item ? '#9b7a65' : 'white'
                    }}
                  >
                    {item}
                  </div>
                )
              }
            })}
          </div>
          <div
            className='pre-btn'
            onClick={() => handleChangePage(nowPage + 1)}
            style={{
              cursor: nowPage === pageTotal ? 'auto' : 'pointer',
              color: nowPage === pageTotal ? 'gray' : '#9b7a65',
              borderColor: nowPage === pageTotal ? 'gray' : '#9b7a65'
            }}
          >
            {'下一页 >'}
          </div>
        </div>
      </div>
      <div className='overview-details-painting-search'>
        <SearchBox selectedType={selectedType} pageType={0} />
      </div>
    </div>
  )
}
